import { render, staticRenderFns } from "./EoiThankYouPage.vue?vue&type=template&id=b3cf524a&scoped=true&"
import script from "./EoiThankYouPage.vue?vue&type=script&lang=js&"
export * from "./EoiThankYouPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cf524a",
  null
  
)

export default component.exports